import { Unstable_Grid2 as Grid } from '@mui/material';

import { TextField, Typography } from '@occc-app/design-system';
import { MarketingContentPreview } from '@occc-app/routes/CampaignComponents/components/MarketingContent/MarketingContentPreview';

import { MarketingContentFormValues, MarketingContentFormValuesPaths } from './types';
import { MarkupInfoAlert } from './MarkupInfoAlert';

type OfferContentDesignSectionProps = {
  marketingContent: MarketingContentFormValues['marketingContent'];
  showExternalUrl?: boolean;
};

const formNamePrefix = 'marketingContent';

export const OfferContentDesignSection = ({
  marketingContent,
  showExternalUrl = false,
}: OfferContentDesignSectionProps) => {
  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Typography variant='subtitle1'>Offer Content</Typography>
      </Grid>

      <Grid xs={12} container sm={6} alignSelf='flex-start'>
        <Grid xs={12}>
          <TextField
            name={`${formNamePrefix}.title` satisfies MarketingContentFormValuesPaths}
            label='Title'
            sx={{ mt: 0 }}
          />
        </Grid>

        <Grid xs={12}>
          <TextField
            name={`${formNamePrefix}.shortDescription` satisfies MarketingContentFormValuesPaths}
            label='Short Description'
            multiline
          />
        </Grid>

        <Grid xs={12}>
          <TextField
            name={`${formNamePrefix}.longDescription` satisfies MarketingContentFormValuesPaths}
            label='Long Description'
            multiline
          />
        </Grid>

        <Grid xs={12}>
          <TextField
            name={`${formNamePrefix}.imageUrl` satisfies MarketingContentFormValuesPaths}
            label='Image URL'
          />
        </Grid>

        {showExternalUrl && (
          <Grid xs={12}>
            <TextField
              name={`${formNamePrefix}.externalUrl` satisfies MarketingContentFormValuesPaths}
              label='External URL'
            />
          </Grid>
        )}
      </Grid>

      <Grid xs={12} sm={6}>
        <MarketingContentPreview marketingContent={marketingContent ?? {}} />
      </Grid>

      <Grid xs={12}>
        <MarkupInfoAlert />
      </Grid>
    </Grid>
  );
};
